var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Text style (huruf T)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.6,20.92a1,1,0,0,0,1.32-.52L5.15,13h5.69l3.24,7.4a1,1,0,1,0,1.83-.8l-7-16a1,1,0,0,0-1.83,0l-7,16A1,1,0,0,0,.6,20.92ZM8,6.5,10,11H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,11H18a1,1,0,0,0,0,2h3a1,1,0,0,1,1,1v1H20a3,3,0,0,0,0,6h1a3,3,0,0,0,1.29-.3A1,1,0,0,0,24,20V14A3,3,0,0,0,21,11Zm0,8H20a1,1,0,0,1,0-2h2v1A1,1,0,0,1,21,19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.835751cc5559f0b9ecbd88a8f50eef11.svg";
export { ForwardRef as ReactComponent };